import { createSelector } from 'reselect';
import { List, Map } from 'immutable';

export const getApiKeysState = (state) =>
  state.apiKeys;

export const getApiKeys = createSelector(
  [getApiKeysState],
  (apiKeys) => {
    const allData = apiKeys?.getIn(['keys', 'data'], Map());
    const pageIds = apiKeys?.getIn(['keys', 'records'], List());
    let pageData = List();
    pageIds.map((id) => {
      const data = allData.getIn([id, 'record']);
      if (data) {
        pageData = pageData.push(data);
      }
    });
    return pageData;
  }
);

export const getLoadingApiKeys = createSelector(
  [getApiKeysState],
  (apiKeys) => {
    return apiKeys?.getIn(['keys', 'loading'], false);
  }
);

export const getNumApiKeysPages = createSelector(
  [getApiKeysState],
  (apiKeys) => {
    return apiKeys?.getIn(['keys', 'totalPages'], 0);
  }
);

export const getTotalApiKeys = createSelector(
  [getApiKeysState],
  (apiKeys) => {
    return apiKeys?.getIn(['keys', 'total'], 0);
  }
);

export const getApiKeyCreationLoading = createSelector(
  [getApiKeysState],
  (apiKeys) => {
    return apiKeys?.getIn(['creation', 'loading'], false);
  }
);

export const getNewApiKeyToken = createSelector(
  [getApiKeysState],
  (apiKeys) => {
    return apiKeys?.getIn(['creation', 'token'], null);
  }
);

export const getNewApiKey = createSelector(
  [getApiKeysState],
  (apiKeys) => {
    return apiKeys?.getIn(['creation', 'newApiKey'], null);
  }
);
